import React from "react";
import CollapsibleSection from "./CollapsibleSection";

const FFLUploadPanel = ({
    isOpen,
    onToggle,
    afterExpand,
    file,
    filePreviewUrl,
    handleFileChange,
    handleDroppedFFL,
    openPhotoModal,
    validationErrors,
    fflFileRef,
    fflDropInputRef,
    isDragOverFile,
    setIsDragOverFile,
    setValidationErrors,
    status,
}) => {
    const isSubdomainLocked = ["Approved", "Live"].includes(status);

    return (
        <CollapsibleSection
            title="📄 Upload Your FFL"
            isOpen={isOpen}
            onToggle={onToggle}
            afterExpand={afterExpand}
        >
            <div className="form-section" ref={fflFileRef}>

                {!isSubdomainLocked ? (
                    <>
                        <small className="note">
                            <p>
                                <span className="required">**</span> Upload a copy of your FFL (PDF, PNG, or JPEG)
                            </p>
                        </small>

                        <div className="file-upload-container">
                            <label
                                className={`custom-file-upload ${validationErrors.fflUpload ? "input-error" : ""}`}
                            >
                                {!isSubdomainLocked ? (
                                    file ? (file.name ? "Update File" : "Upload File") : "Upload File"
                                ) : (
                                    <span className="locked-file-btn">* Locked</span>
                                )}
                                <input
                                    type="file"
                                    name="fflFile"
                                    disabled={isSubdomainLocked}
                                    accept=".pdf, .png, .jpg, .jpeg"
                                    onChange={(e) => {
                                        handleFileChange(e);
                                        if (e.target.files && e.target.files.length > 0) {
                                            setValidationErrors((prev) => ({ ...prev, fflUpload: false }));
                                        }
                                    }}
                                />
                            </label>

                            {file ? (
                                <span
                                    className="file-name clickable"
                                    onClick={() =>
                                        openPhotoModal(
                                            filePreviewUrl,
                                            file.type === "application/pdf" ? "pdf" : "image"
                                        )
                                    }
                                >
                                    {file.name}
                                </span>
                            ) : (
                                <span className="file-name">No file selected.</span>
                            )}
                        </div>

                        <div
                            className={`photo-dropzone ${isDragOverFile ? "drag-over" : ""}`}
                            onClick={() => fflDropInputRef.current?.click()}
                            onDragOver={(e) => {
                                e.preventDefault();
                                const items = e.dataTransfer.items;
                                if (items.length && items[0].kind === "file") {
                                    const type = items[0].type;
                                    if (["application/pdf", "image/jpeg", "image/png"].includes(type)) {
                                        setIsDragOverFile(true);
                                    }
                                }
                            }}
                            onDragLeave={() => setIsDragOverFile(false)}
                            onDrop={(e) => {
                                e.preventDefault();
                                const dropped = e.dataTransfer.files[0];
                                setIsDragOverFile(false);
                                handleDroppedFFL(dropped);
                            }}
                        >
                            <p>📥 Click or Drag & Drop your FFL here</p>
                        </div>

                        <input
                            type="file"
                            ref={fflDropInputRef}
                            style={{ display: "none" }}
                            accept=".pdf, image/jpeg, image/png"
                            onChange={(e) => {
                                const file = e.target.files?.[0];
                                if (file) handleDroppedFFL(file);
                            }}
                        />
                    </>
                ) : (
                    <div>
                        <small className="note">
                            <p className="locked-subdomain-msg">
                                ** FFL file upload is locked after approval. Contact support to request update.
                            </p>
                        </small>

                        <div className="file-upload-container file-upload-container-locked">
                            {file ? (
                                <span
                                    className="file-name clickable"
                                    onClick={() =>
                                        openPhotoModal(
                                            filePreviewUrl,
                                            file.type === "application/pdf" ? "pdf" : "image"
                                        )
                                    }
                                >
                                    {file.name}
                                </span>
                            ) : (
                                <span className="file-name">No file selected.</span>
                            )}
                        </div>
                    </div>
                )}
            </div>
        </CollapsibleSection>
    );
};

export default FFLUploadPanel;